enum WorkflowMethods {
  TRANSITION_BY_STATE_FROM_INDEX = 'transition.by_state_from.index',
}

export default WorkflowMethods;
